import React from "react";  
import { useLocation } from "react-router-dom";  
import useCustomNavigate from "../../common_nextgen/common_components/Navigation/NextGenNavigation";  
import ButtonsSection from '../../common_nextgen/common_components/SearchScreenComponents/ButtonsSection';  
import NoteTable from '../../common_nextgen/common_components/NoteScreenComponents/NoteTable';  
import NextGenPaginator from "../../common_nextgen/common_components/Pagination/NextGenPaginator";  
import usePriceEgdeScheduleNotes from "./hooks/usePriceEgdeScheduleNotes";  
import { useMemo,useCallback } from "react";
import { ROUTE_PATHS } from "../../common_nextgen/utils/Constants.js";
  
const PriceEdgeScheduleNote = () => {  
    const location = useLocation();  
    const { state: stateVal } = location;
    const [currentState = {}] = [...stateVal].reverse();
    const previousState = [...stateVal];
    previousState.splice(stateVal.length - 1, 1);
    const {
      selectedPriceEdge = [],
      previousScreen = ROUTE_PATHS.OUT_OF_POCKET_MAX_SCHEDULE,
      currentIndex: initialIndex = 0,
    } = currentState;
    console.log(
      "states",
      stateVal,
      currentState,
      selectedPriceEdge,
      initialIndex,
      previousState
    );  const navigateToPage = useCustomNavigate();  
  
    const {  
        notes,  
        newNotes,  
        mode,  
        first,  
        rows,  
        totalRecords,  
        currentIndex,  
        setMode,  
        setFirst,  
        setRows,  
        setCurrentIndex,  
        handleSaveNotes,  
        handleChangeNewNote,  
        onPageChange,  
        exportAsCSV  
    } = usePriceEgdeScheduleNotes(selectedPriceEdge, initialIndex);  
  
    const screen_title = "Price Edge Schedule Note";  
    const screen_code = "RCPEN001";  
  
    const columns = mode === 'view'  
        ? [  
            { key: 'penNote', header: 'Note' }  ,
            { key: 'chgDateIso', header: 'Added Date' }, 
            { key: 'chgTimeIso', header: 'Added Time'},
            { key: 'chgUserName', header: 'User'}

        ]  
        : [  
            { key: 'penNote', header: 'Note' }  
        ];  
        const handleBack =useCallback(() => {
            if (currentIndex < selectedPriceEdge.length - 1) {
              setCurrentIndex(currentIndex + 1);
            } else {
              navigateToPage(previousScreen, previousState);
            }
          }, [currentIndex, navigateToPage, setCurrentIndex]);
          
      
          const handleBackAndSetMode = useCallback(() => {
            handleBack();
            setMode("view");
          }, [handleBack, setMode]);
      
          const handleModeSwitch = useCallback(() => {
            if (mode === "add") {
              setMode("view");
            } else if (mode === "view") {
              setMode("add");
            }
          }, [mode]);
      
        const leftButtons = useMemo(
            () => [
              {
                button_label: "Back",
                button_handeler: handleBackAndSetMode,
                button_key: "F12",
              },
              ...(mode === "add"
                ? [
                    {
                      button_label: "View Note",
                      button_handeler: handleModeSwitch,
                      button_key: "F9",
                    },
                  ]
                : []),
            ],
            [mode, handleBackAndSetMode, handleModeSwitch]
          );
          const rightButtons = useMemo(
            () => [
              ...(mode === "view"
                ? [
                    {
                      button_label: "Add Note",
                      button_handeler: handleModeSwitch,
                      button_key: "F9",
                    },
                  ]
                : []),
              { button_label: "Export as CSV", button_handeler: exportAsCSV },
            ],
            [mode]
          );  
          
          const getName = (selectedPriceEdge, currentIndex) => (  
        <>  
            <strong> Schedule </strong>  
            {selectedPriceEdge[currentIndex].pesScheduleName}  
            <span className="info-records">
           <strong>    Description  </strong>
        {selectedPriceEdge[currentIndex].pesScheduleDescription    }
        </span>    
        </>  
    );  
  
    return (  
        <div className="container">  
            <ButtonsSection ctaButtons={leftButtons} align="left" />  
            <div className="left-aligned-section">  
                <div className="header-section">  
                    <h1>  
                        {screen_title} - <span className="heading-cod">{screen_code}</span>  
                    </h1>  
                </div>  
                <p className="head-name">{getName(selectedPriceEdge, currentIndex)}</p>  
            </div>  
            <div className="button-sections">  
                <ButtonsSection ctaButtons={rightButtons} align="right" />  
            </div>  
            <NoteTable  
                data={notes}  
                columns={columns}  
                mode={mode}  
                newNotes={newNotes}  
                handleChangeNewNote={handleChangeNewNote}  
                handleSaveNotes={handleSaveNotes}  
            />  
            <NextGenPaginator  
                first={first}  
                rows={rows}  
                totalRecords={totalRecords}  
                currentPage={first / rows}  
                rowsPerPageOptions={[10, 25, 50]}  
                onPageChange={onPageChange}  
            />  
        </div>  
    );  
};  
  
export default PriceEdgeScheduleNote;  